var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgHandCoins(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M25.061 19.203c1.016-.255 1.685.279 1.877.883.193.607-.05 1.392-.89 1.717-.342.128-1.239.518-2.277.97-1.45.631-3.256 1.416-4.702 1.996-1.863.747-2.49.866-4.463.844l-2.676-.03-.263.512c-.176.592-.611.905-1.262.905H6.081c-.307 0-.601-.145-.806-.397a1.287 1.287 0 01-.245-1.083c.58-2.764 1.763-4.495 3.62-5.291a.43.43 0 11.339.79c-1.58.677-2.6 2.207-3.118 4.677-.041.2.036.322.07.365.042.05.093.08.14.08h4.324c.31 0 .386-.093.446-.316a.433.433 0 01.032-.085l.404-.786a.43.43 0 01.382-.233h.005l2.942.033c1.867.02 2.369-.075 4.133-.782 1.435-.576 3.234-1.358 4.68-1.987 1.089-.474 1.95-.849 2.31-.984.361-.141.451-.43.38-.655-.075-.233-.336-.437-.845-.31l-4.624 1.246c-.157.236-.425.471-.865.673-1.265.58-2.618 1.078-3.713 1.365a.43.43 0 11-.218-.83c1.049-.277 2.351-.756 3.573-1.316.594-.273.566-.499.556-.584a.494.494 0 00-.552-.426c-.238.03-1.102.152-1.938.27-.88.126-1.712.244-1.957.275-.611.076-1.352.017-2.135-.045-.258-.02-.524-.041-.793-.058a.43.43 0 11.054-.858c.276.017.545.039.806.06.74.058 1.437.113 1.962.048.238-.03 1.104-.153 1.942-.272a213.11 213.11 0 011.953-.273 1.355 1.355 0 011.486 1.038l4.243-1.144a.2.2 0 01.007-.002zm-14.36.544a.43.43 0 110 .86.43.43 0 010-.86zM20 12a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 100 4 2 2 0 000-4zm0 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5zm-6-8a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 100 4 2 2 0 000-4zm0 1a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1A.5.5 0 0114 8z"
  }));
}

export default SvgHandCoins;